// CEO Social Lab, small site behaviours. No dependencies.
// Ported from site/site.js. Runs deferred, so the DOM is already parsed.
(function () {
  // Mobile nav: reveal the link list as a stacked panel.
  document.querySelectorAll('.nav .mobile-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = btn.closest('.nav');
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Sticky offer bar: appears once the hero CTA has scrolled away.
  var bar = document.querySelector('.offerbar');
  var trigger = document.querySelector('[data-offerbar-after]');
  if (bar && trigger && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-in', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -100% 0px' }).observe(trigger);
  } else if (bar) {
    bar.classList.add('is-in');
  }
})();
